import React from "react";
import {StyledHeading} from "./heading.style";

const Heading = ({children, as = "h1"}) => {
  return <StyledHeading as={as}>{children}</StyledHeading>;
};

export default Heading;
